import Expandable from './expandable.js';
import { onReady } from './utils.js';

onReady( function() {
	const advancedSearchContainer = document.querySelector( '.c-site-advanced-search-form' );
	if ( ! advancedSearchContainer ) {
		return;
	}

	new Expandable( advancedSearchContainer );
} );
